import { Order } from './order';

export type OrderItemContext = {
    order: Order;
    mouseX: number;
    mouseY: number;
};

export type OrderItemEvent = {
    order: Order;
    eventType: OrderItemEventType;
};

export enum OrderItemEventType {
    MANAGE_EXTERNAL_LAB_USERS,
    MANAGE_INTERNAL_ORDER_ID,
    MANAGE_ATTACHED_SCANS,
    MANAGE_DOWNLOAD_FILES,
    MANAGE_WORKFLOW,
    TOGGLE_TRUCK_ICON,
    MANAGE_LINKED_DENTISTS,
    TOGGLE_PAUSE_STEP,
    MANAGE_ACCEPTED_BY_LAB,
    MANAGE_SENT_BY_LAB,
    MANAGE_APPROVED,
    MANAGE_ARCHIVE,
    START_WORK,
    MANAGE_PAN_NUMBER,
}
